import React from 'react';

const Loading = () => {
  return(
    <div className="loading-screen">Loading...</div>
  )
}

export default Loading;
